export default __webpack_public_path__ + "static/media/gel-buffer-12.1c70a552.svg";